import type { HslBusesPayload, HslBusesResult } from '@jums-dashboard/shared';
import { useQuery } from '@tanstack/react-query';

import { callFunction } from '@/lib/callableClient';

export default function useHslBuses(stopId: string) {
  const fullStopId = `HSL:${stopId}`;
  return useQuery({
    queryKey: ['hsl-buses', fullStopId],
    queryFn: () => callFunction<HslBusesPayload, HslBusesResult>('hslNextBuses', { stopId: fullStopId }),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
